import type { FaireProductEntity } from "../../entity_types/product";

export const p_qgj32tad7u: FaireProductEntity = {
  token: "p_qgj32tad7u",
  type: "product",
  name: "Black Bandana Fringe Cardigan",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/e359fd7cefd01ab34366319f406751e7a800d61b164ddb7aa27646d992251fe6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5c77b3736606452c815a7f5420581eca1fc72303e06bb725c5e2556662ac9d4.jpeg",
    "https://cdn.faire.com/fastly/a843a03bc68b8691e1be17b457ee931c12ec5437252d29c6e738ed38ff18282e.jpeg",
    "https://cdn.faire.com/fastly/fb74ecde1b098e6ea53cebd3a665f2a7c03323bd19400fe79a15436fcff52f18.jpeg",
    "https://cdn.faire.com/fastly/ac409a53e7295828a36eead3eddfbdb15db8a0c4cda79aad6e5de9c800e04256.jpeg"
  ],
  priceDollars: 33.95,
  description: "Black Bandana Fringe Cardigan featuring an allover black bandana-inspired pattern, designed with an open front, self-tie waist closure, two front pockets, long sleeves, and fringe trim along the hem. Finished in a soft knit fabric with a relaxed fit for easy western-inspired layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:55.316Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
